import React from 'react';
import { motion } from 'framer-motion';
const stageTransition = {
  duration: 0.7,
  ease: [0.16, 1, 0.3, 1] as const
};
interface StageProps {
  children: React.ReactNode;
  direction?: number;
  align?: 'center' | 'start';
  className?: string;
  labelledBy?: string;
}

/** Full-viewport stage with a directional, fluid transition. */
export function Stage({
  children,
  direction = 1,
  align = 'center',
  className = '',
  labelledBy
}: StageProps) {
  return <motion.section aria-labelledby={labelledBy} initial={{
    opacity: 0,
    y: direction >= 0 ? 36 : -36,
    filter: 'blur(14px)'
  }} animate={{
    opacity: 1,
    y: 0,
    filter: 'blur(0px)'
  }} exit={{
    opacity: 0,
    y: direction >= 0 ? -28 : 28,
    filter: 'blur(14px)'
  }} transition={stageTransition} className={`relative mx-auto flex w-full max-w-[1400px] flex-col px-6 sm:px-10 lg:px-16 ${align === 'center' ? 'justify-center' : 'justify-start'} ${className}`} data-id="element-445" data-mp="3oy003v97egf8">
      {children}
    </motion.section>;
}
export function Eyebrow({
  children,
  accent,
  className = ''
}: {
  children: React.ReactNode;
  accent?: string;
  className?: string;
}) {
  return <p className={`label-mono flex items-center gap-3 text-[10px] text-mute ${className}`} data-id="element-446" data-mp="1ty78k1dpvymy">
      {accent && <span className="inline-block h-1.5 w-1.5 rounded-full" style={{
      backgroundColor: accent
    }} data-id="element-447" data-mp="22sbrzzqiu7sg" />}
      {children}
    </p>;
}
export function StageTitle({
  children,
  id,
  size = 'display',
  className = ''
}: {
  children: React.ReactNode;
  id?: string;
  size?: 'display' | 'display-sm';
  className?: string;
}) {
  return <h2 id={id} className={`display-tight font-light text-enamel ${size === 'display' ? 'text-display' : 'text-display-sm'} ${className}`} data-id="element-448" data-mp="1p28fi0hg1sg7">
      {children}
    </h2>;
}

/** Word-by-word reveal used for the experience's provocative moments. */
export function RevealText({
  text,
  className = '',
  delay = 0
}: {
  text: string;
  className?: string;
  delay?: number;
}) {
  const words = text.split(' ');
  return <span className={className} data-id="element-449" data-mp="37iirzh3je23r">
      {words.map((word, index) => <motion.span key={`${word}-${index}`} className="inline-block" initial={{
      opacity: 0,
      y: '0.4em',
      filter: 'blur(8px)'
    }} animate={{
      opacity: 1,
      y: 0,
      filter: 'blur(0px)'
    }} transition={{
      duration: 0.65,
      delay: delay + index * 0.055,
      ease: [0.16, 1, 0.3, 1]
    }} data-id="element-450" data-mp="3cidgxf3r4hm6" data-mpi={index}>
          {word}
          {index < words.length - 1 ? '\u00A0' : ''}
        </motion.span>)}
    </span>;
}